module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMP///9sptJHj8fn8Pi20ul4rdbz+PudxOFUl8vC2uyFtdqpy+XO4fDa6fRgns4c/8m5AAAAB3RSTlMAYL8AIM/vi50ITwAAAQVJREFUeF7t2FuKAyEQhWH7lqry2vf9L3U6gVESJjCxzlPwX8CHLyIec6/rSVHfDVdmGMaJlE3jHRpvpO42XtBEgKbBdASpMz0G6g2B+iqoQVaeq4Tsxq85Hyqghf8qJvshdPKbXPgMSvy2hILYoyBeUVCcQRDvNZA8kuAjl+YKKNvzUaBNA5F1GXIqiIRzVgVROZLooAUFJRTkUdABgmbOnSpoz04kDeQ5t9RDdnVcCqDb7wgEBRDkCQMdVgkVBwJtmHdtFwJAzp9E1VD6TeYnQHPXvgdqUIOiEgr5vdBB5VEVLWQfUlwBnxpJabXt49eg/wUbWWCzD2qIgk1jyLHuCjEf/gBROpOU6pX6hgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1f5.png
// module id = 609
// module chunks = 0